import { render, staticRenderFns } from "./ownerIndex.vue?vue&type=template&id=ff5bbf90&scoped=true&"
import script from "./ownerIndex.vue?vue&type=script&lang=js&"
export * from "./ownerIndex.vue?vue&type=script&lang=js&"
import style0 from "./ownerIndex.vue?vue&type=style&index=0&id=ff5bbf90&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff5bbf90",
  null
  
)

export default component.exports